<template>
  <highcharts constructor-type="mapChart" :options="chartOptions" />
</template>

<script>
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import { registerUSAMap } from '@/helpers/map/usaMap';
import HighchartsMapModule from 'highcharts/modules/map';
HighchartsMapModule(Highcharts);
registerUSAMap(Highcharts);

export default {
  name: 'UsaMapChart',
  components: {
    highcharts: Chart,
  },
  props: {
    chartData: Array,
    chartTitleHtml: String,
  },
  data: function () {
    return {
      chartOptions: {
        chart: {
          map: 'USA-map-all',
        },
        title: {
          text: this.chartTitleHtml,
          useHTML: true,
        },
        credits: {
          enabled: false,
        },
        exporting: {
          sourceWidth: 300,
          sourceHeight: 250,
        },

        legend: {
          layout: 'horizontal',
          borderWidth: 0,
          backgroundColor: 'rgba(255,255,255,0.85)',
          floating: true,
          verticalAlign: 'top',
          y: 25,
        },

        mapNavigation: {
          enabled: false,
        },

        colorAxis: {
          min: 1,
          type: 'linear',
          minColor: '#EEEEFF',
          maxColor: '#000022',
          stops: [
            [0, '#EFEFFF'],
            [0.67, '#4444FF'],
            [1, '#000022'],
          ],
        },

        series: [
          {
            animation: {
              duration: 1000,
            },
            data: this.chartData,
            joinBy: ['postal-code', 'state_id'],
            dataLabels: {
              enabled: true,
              color: '#FFFFFF',
              format: '{point.state_id}',
            },
            name: 'Physicians',
            tooltip: {
              pointFormat: '{point.state_id}: {point.value}',
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped></style>
